import React, { useState, useEffect } from 'react';
import { Modal, Button, TextField, Grid, Box, FormControlLabel, Checkbox, Select, MenuItem, InputLabel, FormControl } from '@mui/material';

function TituloVRModal({ open, handleClose, handleSave, usuarioActual }) {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const [titulo, setTitulo] = useState('');
  const [ingresadoPor, setIngresadoPor] = useState(usuarioActual || ''); // Prellenar si se pasa el valor

  const [modulo, setModulo] = useState('');
  const [modulos, setModulos] = useState([]); // Para almacenar los datos de los módulos
  const [error, setError] = useState(''); // Para mostrar errores

  useEffect(() => {
    const fetchModulos = async () => {
      try {
        const response = await fetch(`${server}/MgModuloes/porIdTipo/1`);
        const data = await response.json();
        setModulos(data.$values || []); // Asegurarse de que siempre sea un array
      } catch (error) {
        console.error('Error al cargar los módulos:', error);
        setError('Error al cargar los módulos.');
      }
    };

    fetchModulos();
  }, []);

  const handleGuardar = async () => {
    console.log('handleGuardar se disparó'); // <-- agrega este log
    // if (!titulo) {
    //   setError('Todos los campos son obligatorios.');
    //   return;
    // }

    // Datos a enviar a la API
    const nuevoParametro = {
      titulo,
      ingresadoPor,
    };
console.log(nuevoParametro);
    try {
      // Llamada POST a la API
      const response = await fetch(`${server}/MgAnalitoValoresReferenciaTitulos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(nuevoParametro),
      });

      if (response.ok) {
        // Si la petición fue exitosa
        const data = await response.json();
        console.log('Titulo guardado:', data);

        // Notificar al componente padre
        handleSave(data);

        // Limpiar campos después de guardar
        setTitulo('');
        setIngresadoPor(usuarioActual || '');

        // Cerrar modal
        handleClose();
      } else {
        console.log('Error al guardar el titulo');
        // Si hubo un error en la petición
        const errorData = await response.json();
        setError(`Error al guardar el titulo: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error al guardar el titulo:', error);
      setError('Ocurrió un error al guardar el titulo.');
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          padding: '20px',
          backgroundColor: 'white',
          margin: '50px auto',
          maxWidth: '500px',
          borderRadius: '8px',
          boxShadow: 24,
        }}
      >
        <h2>Agregar Titulo</h2>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Titulo"
              value={titulo}
              onChange={(e) => {
                setTitulo(e.target.value);
                setError(''); // Limpiar el mensaje de error si el usuario empieza a escribir
              }}
              error={!!error && !titulo}
              helperText={!!error && !titulo ? 'El campo titulo es obligatorio.' : ''}
            />
          </Grid>
        
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button onClick={handleGuardar} variant="contained" color="primary">
              Guardar
            </Button>
            <Button
              onClick={handleClose}
              variant="outlined"
              color="secondary"
              style={{ marginLeft: '10px' }}
            >
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default TituloVRModal;
